// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Zdty_VimanIfiM7aInJM{flex-grow:1;margin-left:16px;display:flex;position:relative}.rUzVgn3h5ocUvIwBOLlc{align-items:center;gap:10px;width:100%;min-width:0;display:flex}.rUzVgn3h5ocUvIwBOLlc :has(.JUzAhtRaOYCK2KT0QrI1){min-width:0}.JUzAhtRaOYCK2KT0QrI1{min-width:0}.DlewYyE5LcgoM2sM03kx{flex:none;margin-left:auto;margin-right:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `Zdty_VimanIfiM7aInJM`,
	"nameCell": `rUzVgn3h5ocUvIwBOLlc`,
	"nameText": `JUzAhtRaOYCK2KT0QrI1`,
	"nameToggle": `DlewYyE5LcgoM2sM03kx`
};
export default ___CSS_LOADER_EXPORT___;
